import React, {useEffect, useRef} from 'react';

/* Fired when the user asks about a service from the modal; the request form listens and preselects it. */
export const SELECT_SERVICE_EVENT = 'sw:select-service';

/*
 * "Explore a service" dialog. Closes on Escape, backdrop click, or the close button.
 * Body scroll is locked while open.
 */
const ServiceModal = ({service, onClose}) => {
    const closeRef = useRef(null);

    useEffect(() => {
        if (!service) {
            return undefined;
        }
        const onKey = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', onKey);
        if (closeRef.current) {
            closeRef.current.focus();
        }
        return () => {
            document.body.style.overflow = previousOverflow;
            document.removeEventListener('keydown', onKey);
        };
    }, [service, onClose]);

    if (!service) {
        return null;
    }

    const titleId = `sw-modal-title-${service.slug}`;

    const askAboutService = () => {
        window.dispatchEvent(new CustomEvent(SELECT_SERVICE_EVENT, {detail: service.formOption}));
        onClose();
    };

    return (
        <div className="sw-modal" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="sw-modal__dialog" role="dialog" aria-modal="true" aria-labelledby={titleId}>
                <button ref={closeRef} type="button" className="sw-modal__close" aria-label="Close" onClick={onClose}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                </button>
                <p className="sw-eyebrow">Explore a service</p>
                <h3 id={titleId} className="sw-heading sw-modal__title">{service.title}</h3>
                <p className="sw-modal__description">{service.description}</p>
                <ul className="sw-modal__list">
                    {service.points.map((item) => <li key={item}>{item}</li>)}
                </ul>
                <div className="sw-modal__actions">
                    <a href="#contact" className="sw-modal__btn-primary" onClick={askAboutService}>
                        Ask about this service
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ServiceModal;
